import { render, staticRenderFns } from "./Enrollment.vue?vue&type=template&id=36481e5e&scoped=true"
import script from "./Enrollment.vue?vue&type=script&lang=js"
export * from "./Enrollment.vue?vue&type=script&lang=js"
import style0 from "./Enrollment.vue?vue&type=style&index=0&id=36481e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36481e5e",
  null
  
)

export default component.exports